import { createStore } from 'redux';
const initialState = {
	loginInfo: JSON.parse(localStorage.getItem('loginInfo')) || {},
	menusHistory: JSON.parse(localStorage.getItem('menusHistory') || '[]'),
	menus: [],
	sysMenus: [],
	currenMenu: '',
	parentIds: [],
	headerParentIds:
		localStorage.getItem('headerParentIds') === undefined ? '' : localStorage.getItem('headerParentIds') || '',
	userOrgs: '',
	userInfo: JSON.parse(localStorage.getItem('userInfo')) || {}
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case 'ADD_ARTICLE':
			const newArticle = {
				id: Math.random(),
				title: action.article.title,
				body: action.article.body
			};
			return {
				...state,
				articles: state.articles.concat(newArticle)
			};
		case 'ADD_LOGININFO':
			return {
				...state,
				loginInfo: action.info
			};
		case 'ADD_MENUSHISTORY':
			localStorage.setItem('menusHistory', JSON.stringify(action.info));
			return {
				...state,
				menusHistory: action.info
			};
		case 'DELETE_MENUSHISTORY':
			const { menusHistory } = state;
			const newMenusHistory = menusHistory.filter((item) => item.path !== action.info);
			localStorage.setItem('menusHistory', JSON.stringify(newMenusHistory));
			return {
				...state,
				menusHistory: newMenusHistory
			};
		case 'ADD_MENUS':
			const menus = action.info.map((item) => {
				return {
					id: item.id,
					menus: item.roleFuncList || []
				};
			});

			localStorage.setItem('menus', JSON.stringify(menus));
			return {
				...state,
				menus: menus
			};
		case 'ADD_SYSMENUS':
			return {
				...state,
				sysMenus: action.info
			};
		case 'ADD_CURRENMENU':
			return {
				...state,
				currenMenu: action.info
			};
		case 'ADD_PARENTID':
			return {
				...state,
				parentIds: action.info
			};
		case 'ADD_HEADERPARENTID':
			localStorage.setItem('headerParentIds', action.info);
			return {
				...state,
				headerParentIds: action.info
			};
		case 'ADD_USERORGS':
			return {
				...state,
				userOrgs: action.info
			};
		case 'ADD_USERINFO':
			return {
				...state,
				userInfo: action.info
			};
		default:
			return state;
	}
};
export default createStore(reducer);
